package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMy_server_is_suspendedPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/my_server_is_suspended.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/my-server-is-suspended")
@Layout(".components.layouts.DocsLayout")
@Composable
fun My_server_is_suspendedPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("my-server-is-suspended") }) {
        org.jetbrains.compose.web.dom.Text("My Server is Suspended")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are a few causes why we suspend servers and they are the following:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Not enough coins for the renew:")
            }
            org.jetbrains.compose.web.dom.Text(" go to the ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/earn") {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("generator page")
                }
            }
            org.jetbrains.compose.web.dom.Text(" and claim coins, then unsuspend the server in the ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/manageserver") {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Manage Servers Page")
                }
            }
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Do not skip this reason! It is the most common. Other reasons are VERY rare.")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("You broke the Bot-hosting.net Terms of Service:")
            }
            org.jetbrains.compose.web.dom.Text(" The server might be suspended and will be deleted by the developers. A common cause is hosting a self-bot, which is against Discord ToS too.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("You broke the law:")
            }
            org.jetbrains.compose.web.dom.Text(" The server might be suspended or even straight deleted by the developers. A common cause is hosting a DDoS server.")
        }
    }
}
